import { render, staticRenderFns } from "./TransactionsTableInvoiceColumnContent.vue?vue&type=template&id=72ac3fc0"
import script from "./TransactionsTableInvoiceColumnContent.vue?vue&type=script&lang=js"
export * from "./TransactionsTableInvoiceColumnContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports